import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoadingIcon from '../../../common/icons/LoadingIcon';
import RelatedItemThumbnail from './RelatedItemThumbnail';

import styles from './_styles/ViewRelatedItems.module.scss';

const allActionCreators = Object.assign({});

export class ViewRelatedItems extends Component {

	thumbnailClick(ri) {
		window.location.href = `/ddny/jewelry/${ri.related_product?.id}`;
	}
	
	render() {

		if(!this.props.product) {
			return null;
		}

		return <div className={`${styles.ViewRelatedItems}`}>
			<div className={styles.body}>

				{this.props.product?.related_items?.length > 0
					?	<div className={styles.thumbnailsWrapper}>
							{this.props.product?.related_items.map((ri, n) => {

								return <RelatedItemThumbnail
											key={ri.id} 
											product={this.props.product}
											item={ri}
											onClick={() => this.thumbnailClick(ri)} />;
							})}
														
						</div>
					:	<div className={styles.noItemsWrapper}>
							<div className={styles.copy}>No related items</div>
							<div className={styles.add} onClick={() => this.openEditing()}>Add</div>
						</div>
				}

				{this.props.loading && (
					<div className={styles.loadingWrapper}>
						<div className={styles.iconWrapper}>
							<LoadingIcon />
						</div>
					</div>
				)}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ViewRelatedItems);